let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("9Hipf")).then(() => parcelRequire('it43C'));